import {
  CompetenciesEmployeesRootPageAssessmentGroupFragment,
  CompetenciesProfileRootPageAssessmentGroupFragment,
} from 'generated/resources/graphql'

import BlankSlate from './BlankSlate'
import Competencies from './Competencies/Content'

interface AssessmentsProps {
  assessmentGroups?:
    | CompetenciesProfileRootPageAssessmentGroupFragment[]
    | CompetenciesEmployeesRootPageAssessmentGroupFragment[]
}

const Assessments = ({ assessmentGroups }: AssessmentsProps) => {
  if (!assessmentGroups || assessmentGroups?.length === 0) return <BlankSlate />

  return <Competencies employeeAssessmentGroups={assessmentGroups} />
}

export default Assessments
